import { createContext, useContext } from 'react';
import defaultBackground from './assets/background.png';

export type TBackgroundContext = {
  imageUrl: string | undefined;
  defaultImageUrl: string;
  isBackgroundShown: boolean;
  onAdfoxLoad: (bgImageUrl: string | undefined) => void;
  onAdfoxStub: () => void;
};

export const BackgroundContext = createContext<TBackgroundContext>({
  imageUrl: undefined,
  defaultImageUrl: defaultBackground,
  isBackgroundShown: false,
  onAdfoxLoad: () => {},
  onAdfoxStub: () => {},
});

export const useBackgroundContext = () => useContext(BackgroundContext);
